import { render, staticRenderFns } from "./_image_preview.vue?vue&type=template&id=0892d754&scoped=true&"
import script from "./_image_preview.vue?vue&type=script&lang=js&"
export * from "./_image_preview.vue?vue&type=script&lang=js&"
import style0 from "./_image_preview.vue?vue&type=style&index=0&id=0892d754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892d754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0892d754')) {
      api.createRecord('0892d754', component.options)
    } else {
      api.reload('0892d754', component.options)
    }
    module.hot.accept("./_image_preview.vue?vue&type=template&id=0892d754&scoped=true&", function () {
      api.rerender('0892d754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/_image_preview.vue"
export default component.exports